import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class FileDownloadService {
  async download(jobid: string){
    return await Api().get(`${API_URL}/filedownload/${jobid}`, 
      { headers:  authHeader() as any, responseType: 'blob' });
  }
}

export default new FileDownloadService();